import React from 'react'
import UIkit from 'uikit'
import {
  HashRouter,
  Routes,
  Route,
  NavLink,
  useLocation
} from "react-router-dom"
import i18next from 'i18next'
import { withTranslation } from 'react-i18next'
import Index from './pages/Index'
import Boards from './pages/Boards'
import Instructions from './pages/Instructions'
import Review from './pages/Review'
import CallForPapers from './pages/CallForPapers'
import Archive from './pages/Archive'
import Contact from './pages/Contact'
import { publicRoute } from './helpers/publicRoute'

const Navigation = ({ t }) => {
  let location = useLocation()
  React.useEffect(() => { UIkit.offcanvas('#offcanvas-nav-primary').hide() }, [location])
  return (
    <>
      <li><NavLink to="/borduri"><span className="uk-icon uk-margin-small-right" uk-icon="icon: users"></span>{t('menu.boards')}</NavLink></li>
      <li className="uk-nav-divider uk-hidden@l"></li>
      <li><NavLink to="/instructiuni"><span className="uk-icon uk-margin-small-right" uk-icon="icon: list"></span>{t('menu.instructions')}</NavLink></li>
      <li className="uk-nav-divider uk-hidden@l"></li>
      <li><NavLink to="/analiza"><span className="uk-icon uk-margin-small-right" uk-icon="icon: check"></span>{t('menu.review')}</NavLink></li>
      <li className="uk-nav-divider uk-hidden@l"></li>
      <li><NavLink to="/apel"><span className="uk-icon uk-margin-small-right" uk-icon="icon: bookmark"></span>{t('menu.call_for_papers')}</NavLink></li>
      <li className="uk-nav-divider uk-hidden@l"></li>
      <li><NavLink to="/arhiva"><span className="uk-icon uk-margin-small-right" uk-icon="icon: history"></span>{t('menu.archive')}</NavLink></li>
      <li className="uk-nav-divider uk-hidden@l"></li>
      <li><NavLink to="/contact"><span className="uk-icon uk-margin-small-right" uk-icon="icon: mail"></span>{t('menu.contact')}</NavLink></li>
    </>
  )
}

const Loader = () => (
  <div className='loader'>
    <div>Loading...</div>
  </div>
)

const LanguageSwitch = () => (
  <button
    className="language-button uk-button uk-button-link uk-margin-small-left uk-padding-remove-horizontal"
    onClick={() => i18next.changeLanguage(i18next.language === 'en' ? 'ro' : 'en')}>
    {i18next.language === 'en' ? <img src={publicRoute('rou.svg')} alt="lng-rou" /> : <img src={publicRoute('gbr.svg')} alt="lng-gbr" />}
  </button>
)

function Application({ t }) {
  return (
    <HashRouter>
      <React.Suspense fallback={<Loader />}>
        <div className="application">
          <header className="uk-margin uk-background-secondary uk-light" uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; bottom: #transparent-sticky-navbar">
            <div className="uk-container">
              <nav className="uk-navbar-container uk-navbar-transparent" data-uk-navbar>
                <div className="uk-navbar-left">
                  <div className="uk-navbar-right uk-hidden@l">
                    <button className="uk-button uk-button-link" type="button" uk-toggle="target: #offcanvas-nav-primary"><span className="uk-icon" uk-icon="icon: menu; ratio: 1.5"></span></button>
                  </div>
                  <div className="uk-margin-remove">
                    <NavLink className="uk-navbar-item uk-logo" to="/">
                      <img src={publicRoute('jas-logo.png')} alt="logo" />
                    </NavLink>
                  </div>
                </div>
                <div className="uk-navbar-right uk-visible@l desktop-navigation">
                  <ul className="uk-navbar-nav">{<Navigation t={t} />}</ul>
                  <LanguageSwitch />
                </div>

                <div id="offcanvas-nav-primary" className="uk-hidden@l" data-uk-offcanvas="overlay: true">
                  <div className="uk-offcanvas-bar uk-flex uk-flex-column mobile-navigation">
                    <ul className="uk-nav uk-nav-primary uk-nav-left uk-margin-auto-vertical">
                      {<Navigation t={t} />}
                    </ul>
                    <LanguageSwitch />
                  </div>
                </div>

              </nav>
            </div>
          </header>

          <section className="uk-container uk-margin-top">
            <article className="uk-article">
              <Routes>
                <Route exact path="/" element={<Index />} />
                <Route exact path="/borduri" element={<Boards />} />
                <Route exact path="/instructiuni" element={<Instructions />} />
                <Route exact path="/analiza" element={<Review />} />
                <Route exact path="/apel" element={<CallForPapers />} />
                <Route exact path="/arhiva" element={<Archive />} />
                <Route exact path="/contact" element={<Contact />} />
              </Routes>

            </article>
          </section>

          <footer className="uk-margin-top uk-padding-small uk-background-secondary">
            <div className="uk-container">
              <div className="uk-align-center">
                <div className="uk-container uk-margin-top">
                  <img src={publicRoute('partners.svg')} alt="magazine-partners" data-uk-img />
                </div>
                <h6 className="uk-text-muted uk-margin-remove-bottom">&copy; {t('copyright')} • <strong>{t('magazine_title')}</strong> • {t('department_name')} {new Date().getFullYear()}</h6>
              </div>
            </div>
          </footer>
        </div>
      </React.Suspense>
    </HashRouter>
  )
}

export default withTranslation()(Application)
